/**
 * Overworld ritual types and message constants — AGE-1480.
 *
 * The four core overworld rituals (Light Lantern, Sing to the Wind, Offer at
 * Shrine, Plant Sapling) are general-purpose and share a single state-machine
 * protocol on the wire. Contrast with `ritual.ts` (Ritual Unburdening) and
 * `expedition.ts` (Opening Ritual) which are separate systems.
 *
 * Canonical design: docs/design/rituals.md §§1, 3, 4, 5.
 * §19 describes the shared state-machine rules (pause/resume, server restart,
 * griefing protections).
 *
 * Protocol version: bump OVERWORLD_RITUAL_PROTOCOL_VERSION on breaking changes.
 *
 * @packageDocumentation
 */
export const OVERWORLD_RITUAL_PROTOCOL_VERSION = 1;
// ── Message constants ─────────────────────────────────────────────────
// Client → Server
/** Player requests to begin a ritual at their current position. */
export const MSG_RITUAL_START = 'overworld_ritual_start';
/** Player explicitly abandons an in-progress ritual. */
export const MSG_RITUAL_ABANDON = 'overworld_ritual_abandon';
// Server → Client
/** Ritual completed successfully; ledger entry written. */
export const MSG_RITUAL_COMPLETE = 'overworld_ritual_complete';
/** Periodic progress update while a ritual is in progress. */
export const MSG_RITUAL_PROGRESS = 'overworld_ritual_progress';
/** Ritual was cancelled (player moved away beyond grace period, etc.). */
export const MSG_RITUAL_CANCELLED = 'overworld_ritual_cancelled';
/** A ritual placed an effect in the world (lantern lit, sapling placed, etc.). */
export const MSG_RITUAL_EFFECT = 'overworld_ritual_effect';
//# sourceMappingURL=overworldRitual.js.map